module.exports = __webpack_public_path__ + "static/media/Toggle.78677803.svg";